import { stripSSN } from "../../../services/utils";
import { GET_KELDAN_API_URL } from "../../../services/config";
import {
  IPepWatchFormValues,
  IGetPersonBySSN,
  parsedFieldData
} from "../../../types/PepTypes";
import { IKeldanApiResponse } from "../../../types/KeldanTypes";
import { extractDOBFromSSN, formatDateStringToYYYYMMDD, parseFullName } from "../../../services/pepWatchUtils";
import { IPepWatchResponse } from "../PepWatch";
import { handleBulkAddBody } from "../../../services/pepWatchUtils";

export interface INameParts { firstName: string; middleName: string; lastName: string, rikisfang?: string; }

export const fetchPersonBySSN = async (
  ssn: string
): Promise< INameParts | null> => {
  try {
    const cleanedSSN = stripSSN(ssn);
    const url = `${GET_KELDAN_API_URL()}/pep/GetPersonNameInfo?ssn=${cleanedSSN}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch person data");
    }

    const data: IKeldanApiResponse<IGetPersonBySSN> = await response.json();
    if (data.success) {
      return {
        firstName: data.result?.firstName || "",
        middleName: data.result?.middleName || "",
        lastName: data.result?.lastName || "",
        rikisfang: data.result?.rikisfang || ""
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching person data:", error);
    return null;
  }
};

export const submitSinglePerson = async (values: IPepWatchFormValues): Promise<IKeldanApiResponse<IPepWatchResponse>> => {
  const { firstName, middleName, lastName } = parseFullName(values.name);

  const requestQuery = new URLSearchParams({
    firstName: firstName,
    lastName: lastName,
    countryCode: values.countryCode,
  });
  
  if (middleName) requestQuery.append("MiddleName", middleName);
  if (values.reference) requestQuery.append("Reference", values.reference);
  const dob = extractDOBFromSSN(values.ssn);
  
  if (values.foreign) {
    requestQuery.append("DateOfBirth", formatDateStringToYYYYMMDD(values.dateOfBirth) ?? "");
  } else {
    const id = stripSSN(values.ssn);
    if (id) requestQuery.append("PersonId", id);
    if (dob) requestQuery.append("DateOfBirth", dob);
  }

  if (values.pep && !values.foreign) {
    requestQuery.append("PepFrequency", "daily");
  }
  if (values.sanctions) {
    requestQuery.append("SanctionsFrequency", "daily");
  }

  const url = `${GET_KELDAN_API_URL()}/Pep/AddToPepWatchList`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    body: requestQuery,
  });
  
  return response.json();
};

export const submitBulkData = async (data: parsedFieldData[]): Promise<IKeldanApiResponse<IPepWatchResponse>> => {
  const url = `${GET_KELDAN_API_URL()}/Pep/BulkAddToPepWatchList`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(handleBulkAddBody(data)),
  });
  
  return response.json();
};